export default "__VITE_ASSET__r0nKsgwM__"